import React, { useState } from "react";
import toast from "react-hot-toast";
import "./css/LoginFormModal.css"; // Reuse existing modal styles
import ForgotPasswordAPI from "../services/ForgotPasswordAPI"; // Import ForgotPasswordAPI

function ForgotPassword({ onClose, onGoToLogin }) {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isMouseDownOnBackdrop, setIsMouseDownOnBackdrop] = useState(false); // Track mousedown on backdrop

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }
    try {
      setIsLoading(true);
      await ForgotPasswordAPI.requestPasswordReset(email);

      // Always show the same message for security (prevents email enumeration)
      toast(
        "If the email address you provided is associated with an active account, we will send an email to reset the password.",
        { icon: "ℹ️" },
      );
      onClose();
    } catch (error) {
      console.error("Error requesting password reset:", error);

      // Even on error, show the same message for security
      toast(
        "If the email address you provided is associated with an active account, we will send an email to reset the password.",
        { icon: "ℹ️" },
      );
      onClose();
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackdropMouseDown = (e) => {
    // Only set flag if clicking directly on the backdrop (not on modal content)
    if (e.target.className === "login-modal") {
      setIsMouseDownOnBackdrop(true);
    }
  };

  const handleBackdropMouseUp = (e) => {
    // Only close if mouse was pressed down on backdrop AND released on backdrop
    if (e.target.className === "login-modal" && isMouseDownOnBackdrop) {
      onClose(); // Close the modal when complete click (down + up) happens on backdrop
    }
    // Reset the flag regardless
    setIsMouseDownOnBackdrop(false);
  };

  return (
    <div
      className="login-modal"
      onMouseDown={handleBackdropMouseDown}
      onMouseUp={handleBackdropMouseUp}
    >
      <div className="login-modal-content">
        <h2>Forgot Password</h2>
        <form onSubmit={handleSubmit}>
          {" "}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              disabled={isLoading}
              style={{
                borderColor: errorMessage ? "lightcoral" : "#ddd",
              }}
            />
          </div>
          {errorMessage && (
            <p
              className="error-message"
              style={{ visibility: "visible", opacity: 1 }}
            >
              {errorMessage}
            </p>
          )}
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? "Sending..." : "Submit"}
          </button>
        </form>
        <div className="footer-links">
          Just remembered your password? &nbsp;
          <button
            type="button"
            className="link-button"
            onClick={() => {
              onClose();
              onGoToLogin();
            }}
          >
            <strong>Go back to Login</strong>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
